import moize from "moize";

export default moize(
  function(...args) {
    return Object.assign({}, ...args);
  },
  { isDeepEqual: true }
);
